import CJTemplateId from './CJTemplateId';

export default CJTemplateId;
